import React from "react";
import { compose, withProps, lifecycle } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow,
  DirectionsRenderer,
} from "react-google-maps";
// import { PlusIcon } from "../../asset";
import PlusIcon from "../../asset/Mail-Icon.svg";
import Pin from "../../asset/PinMaps-Icon.svg";
import { useEffect } from "react";
import { useState } from "react";
import { DepotPin } from "../../asset";
import style from "./marker.module.css";
import {
  Pin1,
  Pin2,
  Pin3,
  Pin4,
  Pin5,
  Pin6,
  Pin7,
  Pin8,
  Pin9,
  Pin10,
  Pin11,
  Pin12,
  Pin13,
  Pin14,
  Pin15,
  Pin16,
  Pin17,
  Pin18,
  Pin19,
  Pin20,
  Pin21,
  Pin22,
  Pin23,
  Pin24,
  Pin25,
  Pin26,
  Pin27,
  Pin28,
  Pin29,
  Pin30,
  Pin31,
  Pin32,
  Pin33,
  Pin34,
  Pin35,
  Pin36,
  Pin37,
  Pin38,
  Pin39,
  Pin40,
  Pin41,
  Pin42,
  Pin43,
  Pin44,
  Pin45,
  Pin46,
  Pin47,
  Pin48,
  Pin49,
  Pin50,
  Pin51,
  Pin52,
  Pin53,
  Pin54,
  Pin55,
  Pin56,
  Pin57,
  Pin58,
  Pin59,
  Pin60,
  Pin61,
  Pin62,
  Pin63,
  Pin64,
  Pin65,
  Pin66,
  Pin67,
  Pin68,
  Pin69,
  Pin70,
  Pin71,
  Pin72,
  Pin73,
  Pin74,
  Pin75,
  Pin76,
  Pin77,
  Pin78,
  Pin79,
  Pin80,
  Pin81,
  Pin82,
  Pin83,
  Pin84,
  Pin85,
  Pin86,
  Pin87,
  Pin88,
  Pin89,
  Pin90,
  Pin91,
  Pin92,
  Pin93,
  Pin94,
  Pin95,
  Pin96,
  Pin97,
  Pin98,
  Pin99,
  Pin100,
} from "../../asset/PinMaps";

const MAP_API = "https://maps.googleapis.com/maps/api/js?";
const API_KEY = "AIzaSyBoFXsJLCpUvgSmLqLEQSqaGphqKfxnlfk";

const MapsRoute = compose(
  withProps({
    googleMapURL: `${MAP_API}libraries=places&key=${API_KEY}`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)((props) => {
  const logo = [
    Pin1,
    Pin2,
    Pin3,
    Pin4,
    Pin5,
    Pin6,
    Pin7,
    Pin8,
    Pin9,
    Pin10,
    Pin11,
    Pin12,
    Pin13,
    Pin14,
    Pin15,
    Pin16,
    Pin17,
    Pin18,
    Pin19,
    Pin20,
    Pin21,
    Pin22,
    Pin23,
    Pin24,
    Pin25,
    Pin26,
    Pin27,
    Pin28,
    Pin29,
    Pin30,
    Pin31,
    Pin32,
    Pin33,
    Pin34,
    Pin35,
    Pin36,
    Pin37,
    Pin38,
    Pin39,
    Pin40,
    Pin41,
    Pin42,
    Pin43,
    Pin44,
    Pin45,
    Pin46,
    Pin47,
    Pin48,
    Pin49,
    Pin50,
    Pin51,
    Pin52,
    Pin53,
    Pin54,
    Pin55,
    Pin56,
    Pin57,
    Pin58,
    Pin59,
    Pin60,
    Pin61,
    Pin62,
    Pin63,
    Pin64,
    Pin65,
    Pin66,
    Pin67,
    Pin68,
    Pin69,
    Pin70,
    Pin71,
    Pin72,
    Pin73,
    Pin74,
    Pin75,
    Pin76,
    Pin77,
    Pin78,
    Pin79,
    Pin80,
    Pin81,
    Pin82,
    Pin83,
    Pin84,
    Pin85,
    Pin86,
    Pin87,
    Pin88,
    Pin89,
    Pin90,
    Pin91,
    Pin92,
    Pin93,
    Pin94,
    Pin95,
    Pin96,
    Pin97,
    Pin98,
    Pin99,
    Pin100,
  ];
  //TODO convert css to svg
  const InvisibleMarker = (loc, index) => {
    const invisibleMarkerStyle = {
      width: "30px",
      height: "30px",
      borderRadius: "50% 50% 50% 0",
      background: "#89849b",
      position: "absolute",
      transform: "rotate(-45deg)",
      left: "50%",
      top: "50%",
      margin: "-20px 0 0 -20px",
      animationName: "bounce",
    };

    return <Marker icon={invisibleMarkerStyle} />;
  };
  console.log("direc", props.directions2);

  return (
    <>
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{
          lat: Number(props?.data[0]?.latitude),
          lng: Number(props?.data[0]?.longitude),
        }}
      >
        {/* {props?.directions !== undefined ? */}
        <>
          <DirectionsRenderer
            directions={props?.directions}
            options={{
              polylineOptions: {
                strokeOpacity: 0.8,
                strokeColor: "#CF0000",
                strokeWeight: 6,
              },
              suppressMarkers: true,
            }}
          />
          {/* {
  props.paging === 1 ? */}
          <Marker
            name="title"
            position={{
              lat: props.lat,
              lng: props.long,
            }}
            icon={{
              url:
                props.paging === 1
                  ? DepotPin
                  : logo[(props.paging - 1) * 25 - 1],
              // anchor: new window.google.maps.Point(5, 58),
            }}
          />
          :<></>
          {/* } */}
          {/* {InvisibleMarker()} */}
          {/* <Marker
              name="title"
              position={props?.directions?.routes[0]?.legs[0]?.end_location}
              icon={{
                url: <div className={style.a}/>,
              }}
            /> */}
          {props?.datas?.map((loc, index) => (
            <>
              <Marker
                key={loc.order_id}
                name={loc.location}
                position={{
                  lat: loc.latitude,
                  lng: loc.longitude,
                }}
                // onClick={() => props.handleMouseOver(loc, index)}
                // onMouseOut={() => props.onMouseOut(loc, index)}
                icon={{
                  url: logo[index + (props.paging - 1) * 25],
                  // url: <div className={style.a}/>,
                  // anchor: new window.google.maps.Point(5, 58),
                }}
              >
                {/* {InvisibleMarker()} */}
                {/* {loc.showTooltip && (
                  <InfoWindow onCloseClick={() => props.handleMouseClose(loc)}>
                    <h4>{loc.formatted_address}</h4>
                  </InfoWindow>
                )}  */}
              </Marker>
            </>
          ))}
        </>
        {/* : ""} */}
      </GoogleMap>
    </>
  );
});

export default MapsRoute;
